import React from 'react';
import { useTranslation } from 'react-i18next';
import { QueryResult } from '@apollo/client';
import { NewSection } from '../NewSection';
import { CardsLayout } from '../ui/CardsLayout';
import { ItemCard } from '../ui/ItemCard';
import { getSearchVippedItemsUrl } from '../../utils/helpers';
import useScreenSize from '../../hooks/useScreenSize';
import { useClient } from '../../hooks/useClient';
import { useBookmarks } from '../../hooks/useBookmarks';
import { ItemSectionSkeleton } from './ItemSectionSkeleton';
import { TransformedObj } from './types';
import { SearchVippedAllQuery } from '../../graphql/graphql';

interface VipItemsSectionProps {
  transformedObj: TransformedObj;
  searchVippedQuery: QueryResult<SearchVippedAllQuery>;
}

export const VipItemsSection: React.FC<VipItemsSectionProps> = ({
  transformedObj,
  searchVippedQuery
}) => {
  const { isSmall, isLarge } = useScreenSize();
  const { t } = useTranslation();
  const isClient = useClient();
  const { isBookmarked } = useBookmarks();

  const searchVippedItemsUrl = getSearchVippedItemsUrl(
    transformedObj.filter || {}
  );
  const getVipListLimit = () => {
    switch (true) {
      case isLarge || !isClient: // show max count of cards and hide is with styles
        return 8;
      case isSmall:
        return 4;
      default:
        return 6;
    }
  };

  const itemsVipList = (searchVippedQuery.data?.vipItems || [])
    .slice(0, getVipListLimit())
    .map(item => (
      <ItemCard key={item.id} {...item} inBookmarks={isBookmarked(item.id)} />
    ));

  if (!itemsVipList.length && !searchVippedQuery.loading) return null;

  return (
    <NewSection
      id="search-page-vipped"
      title={t('sections.vipped.title')}
      url={searchVippedItemsUrl}
      urlTitle={t('sections.residences.show_all')}
      headlineType="h3"
      cypress="vipped-section-title"
    >
      {itemsVipList.length ? (
        <CardsLayout
          countOfVisibleMobileCards={4}
          countOfVisibleTabletCards={6}
        >
          {itemsVipList}
        </CardsLayout>
      ) : (
        <ItemSectionSkeleton />
      )}
    </NewSection>
  );
};
